(function() {
    "use strict";

    var sidenavController = function ($scope) {

        $scope.toggleSideNav = function() {
            $scope.showSideNav = ! $scope.showSideNav;
        }
    };

    taillightUx.directive('tuxSidenavOption', TuxSideNav);

    function TuxSideNav() {
        return {
            template: function(element, attr) {

                var body = getTemplate();

                return '<div class="tux-sidenav-overlay" data-ng-class="{\'opened\': showSideNav}" data-ng-click="toggleSideNav()"></div>' +
                '<div class="tux-sidenav tux-shadow-2" data-ng-class="{\'opened\': showSideNav}">' +
                body +
                '</div>';

                function getTemplate() {
                    var content = element.eq(0),
                        template = content.length ? content.html() : '';
                    return template;
                }
            },
            restrict: 'E',
            scope: { showSideNav: "=" },
            controller: ['$scope', sidenavController]
        }
    }

    taillightUx.directive('tuxSidenav', TuxSideNav);

}());